import { defineStore } from 'pinia'
import authService from '@/services/auth'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: authService.getUser(),
    token: authService.getToken(),
    isAuthenticated: !!authService.getToken()
  }),

  getters: {
    isAdmin: (state) => state.user?.role === 'admin' || state.user?.user_type === 'platform_user',
    isProjectManager: (state) => state.user?.role === 'project_manager',
    isFinance: (state) => state.user?.role === 'finance',
    isDonor: (state) => state.user?.role === 'donor',
    canManageProjects: (state) => {
      return state.user?.role === 'admin' || 
             state.user?.role === 'project_manager' ||
             state.user?.user_type === 'platform_user'
    },
    canApproveExpenses: (state) => {
      return state.user?.role === 'admin' || 
             state.user?.role === 'finance' ||
             state.user?.user_type === 'platform_user'
    }
  },

  actions: {
    async login(email, password) {
      const data = await authService.login(email, password)
      this.user = data.user
      this.token = data.token
      this.isAuthenticated = true
      authService.setAuth(data.token, data.user)
      return data
    },

    async register(userData) {
      const data = await authService.register(userData)
      this.user = data.user
      this.token = data.token
      this.isAuthenticated = true
      authService.setAuth(data.token, data.user)
      return data
    },

    logout() {
      this.user = null
      this.token = null
      this.isAuthenticated = false
      authService.logout()
    }
  }
})
